import deepEqual from './deepEqual.js';

const memos = {};

const memoizeSelector =
  (memoKey, fn) =>
  (...args) => {
    const memoObjectKey = `${memoKey}Object`;

    const fnResult = fn(...args);
    if (memos[memoObjectKey] !== undefined && deepEqual(fnResult, memos[memoObjectKey])) {
      return memos[memoObjectKey];
    }

    memos[memoObjectKey] = fnResult;
    return fnResult;
  };

export default memoizeSelector;
